<div *ngIf="isFansZero" class="alert valign-children-middle errorMsg" id="error-main-container">
  <div class="alert-error" role="img" aria-label="Error" aria-hidden="true">
    <i class="icon-badgealert"></i>
  </div>
  <div>
    <h2>Error</h2>
    <p class="error-message">{{accountsData.content.errorMessage}}</p>
    <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
  </div>
</div>



<!-- <div *ngIf="showGoogleCreationError" id="alertMessage" class="alert valign-children-middle">
  <div class="alert-error" role="img" aria-label="Alert">
    <i class="icon-badgealert"></i>
  </div>
  <div>
    <span *ngIf="showGoogleCreationError">{{accountsData.content.errorMessageGoogle.apiError}}&nbsp;
      {{accountsData.content.errorMessageGoogle.apiErrorDesc}}</span>
    <span *ngIf="!showGoogleCreationError">{{accountsData.content.error}}</span>
  </div>
</div> -->
<div class="main-wrapper msg-box1 fan-selection" *ngIf="!isFansZero">
  <section class="signup-section" *ngIf="accountsData.content">
    <div *ngIf="isROMEFailed" class="alert valign-children-middle" id="error-main-container2">
      <div class="alert-error" role="img" aria-label="Error" aria-hidden="true">
        <i class="icon-badgealert"></i>
      </div>
      <div>
        <h2>Error</h2>
        <p class="error-message">{{IFDErrorMessage}}</p>
        <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
      </div>
    </div>
    <section class="signupwithnotab" *ngIf="!haveTab && !haveAccordion">
      <!-- <div *ngIf="productSelected === 'DMPSKME'">
        <h6>Step 2 of 3</h6>
        <h2>{{accountsData.content.heading}}</h2>
        <p class="margin-p">
          <span>{{accountsData.content.note}}</span>
          <a href="assets/pdf/GoogleZTP.pdf" target="_blank" *ngIf="ztp">{{prodcode}} Service Guide</a>
          <a href="assets/pdf/SamsungKnoxMobileEnrollment.pdf" target="_blank" *ngIf="kme">{{prodcode}} Service
            Guide</a>
          <a href="https://support.apple.com/guide/apple-business-manager/welcome/web" target="_blank"
            *ngIf="abm">{{prodcode}} User Guide</a>.
        </p>
        <br>
        <p>{{accountsData.content.selectedFans}}</p>
        <br>
      </div> -->
      <div *ngIf="productSelected === 'DMPAABM'">
        <h5>Step 2 of 3</h5>
        <p class="margin-p">
          <span><strong>{{accountsData.content.noTabawaitingSignupFanList.abmHeading}}</strong></span>
          <br>
          <br>
          <span>{{accountsData.content.noTabawaitingSignupFanList.abmDescription1}}
            <a href="https://business.apple.com/" target="_blank"> Apple Business </a>
            {{accountsData.content.noTabawaitingSignupFanList.abmDescription2}}
          </span>
      </div>
      <div *ngIf="productSelected === 'DMPGZTP'">
        <h5>Step 2 of 3</h5>
        <p class="margin-p">
          <span><strong>{{accountsData.content.noTabawaitingSignupFanList.abmHeading}}</strong></span>
          <br>
          <br>
          <span>{{accountsData.content.noTabawaitingSignupFanList.zteDescription1}}
            <a style="text-decoration: underline;" href="https://accounts.google.com/v3/signin/identifier?continue=https%3A%2F%2Fenterprise.google.com%2Fandroid%2Fzero-touch%2Fcustomers&followup=https%3A%2F%2Fenterprise.google.com%2Fandroid%2Fzero-touch%2Fcustomers&ifkv=AdBytiPIrFA7cBGoiPBZo0TrpKqhK5DJ7B_pV7qDch9NVUtcQpV2K0-9CL5jPRDDftSLNgLXtlcRCw&osid=1&passive=1209600&flowName=GlifWebSignIn&flowEntry=ServiceLogin&dsh=S153336226%3A1750884786396781"
             target="_blank"> Android™ zero-touch</a>
            {{ accountsData.content.noTabawaitingSignupFanList.zteDescription2}}
          </span>
      </div>
      <div *ngIf="productSelected === 'DMPSKME'">
        <h5>Step 2 of 3</h5>
        <p class="margin-p">
          <span><strong>{{accountsData.content.noTabawaitingSignupFanList.abmHeading}}</strong></span>
          <br>
          <br>
          <span>{{accountsData.content.noTabawaitingSignupFanList.kmeDescription1}}
          </span>
      </div>
      <!-- <div class="new-tooltip-input inline-labels">
        <i [ngClass]="{'tooltip-zte' : productSelected === 'DMPGZTP', 'tooltip-kme' : productSelected === 'DMPSKME'}" class="icon-flat-faq tooltip-icon faq-tooltip-icon new-tooltips" tabindex="0" aria-describedby="inputhelp"
          (mouseenter)="toggleTooltipEnter($event)" (mouseleave)="toggleTooltipLeave($event)" aria-label="Help"></i>
        <div role="tooltip" [ngClass]="{'tooltipContent-zte' : productSelected === 'DMPGZTP', 'tooltipContent-kme' : productSelected === 'DMPSKME'}" class="helper-content tooltip-content helper-text" id="inputhelp">
          {{accountsData.content.existingDevicesTooltipContent}}</div>
      </div> -->
      
      <!-- <div *ngIf="abm" class="tooltip-input inline-labels">
        <i class="icon-flat-faq tooltip-icon faq-tooltip-icon" tabindex="0" aria-describedby="inputhelp"
          (mouseenter)="toggleTooltipEnter($event)" (mouseleave)="toggleTooltipLeave($event)" aria-label="Help"></i>
        <div role="tooltip" class="helper-text" id="inputhelp">
          {{accountsData.content.existingDevicesTooltip}}1</div>
      </div> -->
      
      <app-customgrid [gridOptions]="gridOptions[0]" (onDataChange)="onRowClick($event)" *ngIf="gridOptions[0]">
        <!-- <ng-template let-row="row">
          <label class="checkbox" id="enroll-label">
            <input type="checkbox" aria-describedby="enroll-existing-devices" aria-label="Enroll" name="enroll-devices"
              (click)="existingDevices(row)" [disabled]="!row.selected" [(ngModel)]="row.enroll"
              [ngModelOptions]="{standalone: true}">
            <i class="skin"></i>
            <span id="enroll-existing-devices">{{accountsData.content.enroll}}</span>
          </label>

        </ng-template> -->
        <ng-template let-row="row">
          <label class="toggle-switch" id="enroll-label">
            <input type="checkbox" aria-describedby="enroll-existing-devices" aria-label="Enroll" name="enroll-devices"
              (click)="existingDevices(row)" [disabled]="!row.selected" [(ngModel)]="row.enroll"
              [ngModelOptions]="{standalone: true}">
            <span class="slider"></span>
            <!-- <span *ngIf="!isMobileView" id="enroll-existing-devices">{{accountsData.content.enroll}}</span> -->
          </label>
        </ng-template>

      </app-customgrid>

      <!-- <div *ngIf="abm" class="legalAgreement">
        <h3>{{accountsData.content.termsAndCondition.legalAgreement1}}</h3>
        <br />
        <p>{{accountsData.content.termsAndCondition.description7}}
          <a [href]="staticTcUrl" target="_blank">{{accountsData.content.termsAndCondition.link6}}</a>.
        </p>
        <p *ngIf="!abm">Use of {{prodcode}} is subject to the Terms & Conditions in the
          <a href="assets/pdf/GoogleZTP.pdf" target="_blank" *ngIf="ztp">{{prodcode}} Service Guide</a>
          <a href="assets/pdf/SamsungKnoxMobileEnrollment.pdf" target="_blank" *ngIf="kme">{{prodcode}} Service
            Guide</a>
        </p>
        <p *ngIf="abm">Use of {{prodcode}} is subject to the Terms & Conditions on the
          <a href="https://business.apple.com" target="_blank" *ngIf="abm">{{prodcode}} portal</a>.
        </p>
      </div> -->

      <section *ngIf="productSelected" class="button-section col-sm-12 col-md-12 text-right d-flex justify-content-between">
        <button (click)="enterOrgIdPage()" class="btn btn-secondary back-btn">
          {{accountsData.content.buttons.back}}
        </button>
        <button id="accounts-btn" [disabled]="!this.enableCont || showError" (click)="continueToNext()"
          href="javascript:void(0)" class="btn btn-secondary pull-right continue-btn">
          {{accountsData.content.buttons.continue}}
        </button>
      </section>

      <!-- <section *ngIf="emmProductCode === 'DMPSKME'" class="button-section col-sm-12 col-md-12  text-right mobile continue-button" style="display: inline-block !important;">
        <button [disabled]="!enableCont || showError" (click)="continueToNext()" aria-label="Continue."
          href="javascript:void(0)"
          class="btn btn-secondary btn-continue pull-right continue-btn">{{accountsData.content.buttons.continue}}</button>
        <button id="cancel" (click)="backToInitialSetup($event)"
          class="btn btn-link btn-block btn-cancel cancel-button back-btn">{{accountsData.content.buttons.back}}</button>
      </section> -->

    </section>

    <section class="signuptabcontainer" *ngIf="haveTab">
      <app-tabs [tabs]="tabArray" [ariaLabel]="'Device enrollment'">
        <app-tab class="app-tab" *ngFor='let td of tabArray; let i = index;' [option]="td" (click)="selectedTab(i);">
          <div>
            <p>
              <span>{{accountsData.content.note}}</span>
              <a href="assets/pdf/GoogleZTP.pdf" target="_blank" *ngIf="ztp">{{prodcode}} Service Guide</a>
              <a href="assets/pdf/SamsungKnoxMobileEnrollment.pdf" target="_blank" *ngIf="kme">{{ prodcode === 'Samsung Knox Mobile' ? 'Samsung Knox Mobile Enrollment' : prodcode }} Service
                Guide</a>
              <a href="https://support.apple.com/guide/apple-business-manager/welcome/web" target="_blank"
                *ngIf="abm">{{ prodcode === 'Apple Business Manager' ? 'Apple Business' : prodcode }} Service Guide</a>.
            </p>
            <p *ngIf="!selectedFansCount[i]">{{accountsData.content.selectedFans}}</p>
            <p *ngIf="selectedFansCount[i]">{{selectedFansCount[i]}}</p>
          </div>
          <div class="tooltip-input inline-labels">
            <i class="icon-flat-faq tooltip-icon" tabindex="0" aria-describedby="inputhelp"
              (mouseenter)="toggleTooltipEnter($event)" (mouseleave)="toggleTooltipLeave($event)" aria-label="Help"></i>
            <div role="tooltip" class="helper-text" id="inputhelp">
              {{accountsData.content.existingDevicesTooltip}}</div>
          </div>
          <app-customgrid *ngIf="td.isActive" [gridOptions]="gridOptions[i]" (onDataChange)="onRowClick($event)">

            <ng-template let-row="row">
              <label class="checkbox" id="enroll-label">
                <input type="checkbox" #enrollBox aria-describedby="enroll-existing-devices" aria-label="Enroll"
                  name="enroll-devices" (click)="existingDevices(row)" [disabled]="!this.enrollEnable">
                <i class="skin"></i>
                <!-- <span id="enroll-existing-devices">{{accountsData.content.enroll}}</span> -->
              </label>
            </ng-template>
          </app-customgrid>

          <br>

          <div *ngIf="abm" class="legalAgreement">
            <h3>{{this.initialModel.productSelection.header3}}</h3>
            <br />
            <p>{{this.initialModel.productSelection.description7}}
              <a [href]="staticTcUrl" target="_blank">{{this.initialModel.productSelection.link6}}</a>.
            </p>
            <p>Use of {{ prodcode === 'Apple Business Manager' ? 'Apple Business' : prodcode }} is subject to the Terms & Conditions in the
              <a href="assets/pdf/GoogleZTP.pdf" target="_blank" *ngIf="ztp">{{prodcode}} Service Guide</a>
              <a href="assets/pdf/SamsungKnoxMobileEnrollment.pdf" target="_blank" *ngIf="kme">{{ prodcode === 'Samsung Knox Mobile' ? 'Samsung Knox Mobile Enrollment' : prodcode }} Service
                Guide</a>
              <a href="https://support.apple.com/guide/apple-business-manager/welcome/web" target="_blank"
                *ngIf="abm">{{ prodcode === 'Apple Business Manager' ? 'Apple Business' : prodcode }} Service Guide</a>.
            </p>
          </div>

          <section class="buttons-section col-sm-12 col-md-12 text-right">
            <button id="accounts-btn" [disabled]="!this.enableCont || showError" (click)="continueToNext()"
              href="javascript:void(0)"
              class="btn btn-secondary pull-right continue-btn">{{accountsData.content.buttons.continue}}</button>
            <a href="#" (click)="backToInitialSetup($event)"
              class="btn btn-link bt-block btn-cancel back-btn">{{accountsData.content.buttons.cancel}}</a>
          </section>
        </app-tab>
      </app-tabs>
    </section>

  </section>
</div>